import React from "react"
import { Box } from "@mui/material"
import PartBrowser from "components/PartBrowser/PartBrowser"

const PartBrowserPage = () => (
  <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
    <PartBrowser mode="page" />
  </Box>
)

export default PartBrowserPage
